import { saveObj, saveString, getString, getObj } from "./localStorage"
import { mergeObjIfExist } from "./utils"
import ImgAvatar from "src/assets/images/avatar.jpg"
import { HCF } from "@macashipo/mlib"
import { KConfigApp } from "src/helpers/K"

const AuthInfo: any = {
  kAuthToken: "Auth-Token",
  kAuthType: "Auth-Type",
  kAuthInfo: "Auth-Info",
  kAuthInfoSocial: "Auth-InfoSocial",
  kAuthMenu: "Auth-Menu",
  kHomepageUrl: "Auth-Homepage",
  token: "",
  type: "Bearer",
  info: {},
  infoSocial: null,
  info2FA: {},
  checkBeforeLogout: {},
  listAfterLogout: {},
}

const AuthConfig: IAuthConfig = {
  afterLogout: () => {},
  afterLogin: () => {},
}

export const initAuth = (config?: IAuthConfig) => {
  mergeObjIfExist(AuthConfig, config)
  loadLastSaved()
}
export const authCheckSavedAuthorized = () => {
  let _token = getString(AuthInfo.kAuthToken, "")
  if (_token) {
    return true
  }
  return false
}

export const authGetAuthorizationHeader = () => {
  // console.warn("authGetAuthorizationHeader:", AuthInfo)
  if (AuthInfo.token) {
    return `${AuthInfo.type} ${AuthInfo.token}`
  }
}

const loadLastSaved = () => {
  // AuthInfo.auth = data;
  let _obj = {
    type: getString(AuthInfo.kAuthType, AuthInfo.type),
    token: getString(AuthInfo.kAuthToken, ""),
    info: getObj(AuthInfo.kAuthInfo, {}),
  }
  if (_obj.token) {
    authLogin(_obj)
  }
}
const savedLocal = () => {
  saveString(AuthInfo.kAuthType, AuthInfo.type)
  saveString(AuthInfo.kAuthToken, AuthInfo.token)
  saveObj(AuthInfo.kAuthInfo, AuthInfo.info)
  HCF.setCF(KConfigApp.AuthInfo, AuthInfo.info)
}

export const authLogin = (data: IAuth) => {
  mergeObjIfExist(AuthInfo, data)
  savedLocal()
  // console.warn("authLogin:", data)
  if (AuthConfig.afterLogin) {
    AuthConfig.afterLogin()
  }
}

const getInfoFromData = function (data: any) {
  let _info = {}
  for (let k of Object.keys(data)) {
    if (k !== "access_token" && k !== "token_type") {
      _info[k] = data[k]
    }
  }
  return _info
}
const parse2FAfromData = function (data: any) {
  if (data) {
    AuthInfo.info2FA["fa2_needenable"] = data.fa2_needenable
    AuthInfo.info2FA["fa2_needverify"] = data.fa2_needverify
    AuthInfo.info2FA["fa2_token"] = data.fa2_token
    AuthInfo.info2FA["user_uniqueid"] = data.user_uniqueid
    AuthInfo.info2FA["user_id"] = data.user_id
    AuthInfo.info2FA["fa2_method"] = data.fa2_method
    AuthInfo.info2FA["user_type"] = data.user_type
  }
}
export const authLoginWithRes = (data: any): boolean => {
  // console.warn("authLoginWithRes:", data)
  let needReset = false
  if (data?.user_type && data.user_type.indexOf("ForgotPassword_") > -1) {
    needReset = true
  }
  if (!needReset) {
    parse2FAfromData(data)
    if (data && data.access_token) {
      let _info = getInfoFromData(data)
      let _obj = {
        token: data.access_token,
        type: data.token_type,
        info: _info,
      }
      authLogin(_obj)
      return true
    }
  }
  return false
}
export const authLoginSocialWithRes = (data: any): boolean => {
  if (data) {
    if (data.Token) {
      parse2FAfromData(data.Token)
    }
    if (data.Token && data.Token.access_token) {
      let _info = getInfoFromData(data.Token)
      let _obj = {
        token: data.Token.access_token,
        type: data.Token.token_type,
        info: _info,
        infoSocial: data.SocialInfo,
      }
      authLogin(_obj)
      return true
    }
  }
  return false
}

export const setHomepageUrl = (url: string) => {
  saveString(AuthInfo.kHomepageUrl, url)
}

export const getHomepageUrl = (): string => {
  return getString(AuthInfo.kHomepageUrl, "/")
}

export const clearHomepageUrl = () => {
  localStorage.removeItem(AuthInfo.kHomepageUrl)
}

export const authLogoutWithNothing = () => {
  localStorage.removeItem(AuthInfo.kAuthToken)
  localStorage.removeItem(AuthInfo.kAuthInfo)
  localStorage.removeItem(AuthInfo.kAuthType)
  clearHomepageUrl()
  sessionStorage.removeItem("_menuFetchedByLogin")
  AuthInfo.info2FA = {}
  AuthInfo.info = {}
  AuthInfo.token = ""
}

export const authLogout = ({ forceLogout, cbLogout }: any = {}) => {
  // localStorage.removeItem(AuthInfo.kAuthToken)
  // localStorage.removeItem(AuthInfo.kAuthInfo)
  // localStorage.removeItem(AuthInfo.kAuthType)
  // localStorage.removeItem(AuthInfo.kAuthMenu)
  // AuthInfo.info2FA = {}
  // AuthInfo.info = {}
  // AuthInfo.token = ""
  // if (AuthConfig.afterLogout) {
  //   AuthConfig.afterLogout()
  // }
  let _isWillLogout = false
  if (checkBeforeLogout()) {
    _isWillLogout = true
  }
  if (forceLogout === true) {
    _isWillLogout = true
  }
  if (_isWillLogout) {
    authLogoutWithNothing()
    afterLogout()
    if (cbLogout) {
      cbLogout()
    }
  }
}

export const authIsLogged = () => {
  return AuthInfo.token ? true : false
}

export const getUserInfo = (): any => {
  return AuthInfo.info
}

export const getInfo2FA = () => {
  return AuthInfo.info2FA
}

export const getUserID = () => {
  return getUserInfo()?.user_id
}

export const getUserName = () => {
  return getUserInfo()?.name
}

export const getUserEmail = () => {
  return getUserInfo()?.user_name
}

export const getUserAvatar = () => {
  if (getUserInfo() && getUserInfo()["avatar_url"]) {
    return getUserInfo()?.avatar_url
  }
  return ImgAvatar
}

export const getUserLogoApp = () => {
  return getUserInfo()?.appLogo_url
}

export const getKeyMenuLocal = () => {
  return AuthInfo.kAuthMenu
}

export const cacheMenuAfterLogin = (menuList: any[]) => {
  const list = menuList || []
  localStorage.setItem(AuthInfo.kAuthMenu, JSON.stringify(list))
  if (list.length > 0) {
    sessionStorage.setItem("_menuFetchedByLogin", "1")
  }
}

export const getMenuAllowedCodes = (): string[] => {
  const menuList = getObj(AuthInfo.kAuthMenu, [])
  return menuList.map((v: any) => v.ScreenCode).filter(Boolean)
}
export const checkShow2FAFromTokenResponse = resToken => {
  if (resToken) {
    if (resToken.fa2_needenable || resToken.fa2_needverify) {
      return true
    }
  }
  return false
}
export const registerAfterLogout = (key, fn) => {
  if (key) {
    if (fn) {
      AuthInfo.listAfterLogout[key] = fn
    } else {
      delete AuthInfo.listAfterLogout[key]
    }
  }
}
const afterLogout = () => {
  if (AuthConfig.afterLogout) {
    AuthConfig.afterLogout()
  }
  if (AuthInfo.listAfterLogout) {
    for (let k of Object.keys(AuthInfo.listAfterLogout)) {
      let _fn = AuthInfo.listAfterLogout[k]
      if (_fn) {
        _fn()
      }
    }
  }
}
export const checkBeforeLogout = () => {
  if (AuthInfo.checkBeforeLogout) {
    for (let k of Object.keys(AuthInfo.checkBeforeLogout)) {
      let _fn = AuthInfo.checkBeforeLogout[k]
      if (_fn) {
        let _check = _fn()
        if (_check === false) {
          return false
        }
      }
    }
  }
  return true
}
export const registerCheckBeforeLogout = (key, fn) => {
  if (key) {
    if (fn) {
      AuthInfo.checkBeforeLogout[key] = fn
    } else {
      delete AuthInfo.checkBeforeLogout[key]
    }
  }
}
